import { message, notification } from "antd";
import AlertMessage from "../../ui/components/AlertMessage";

export interface INotificationService {
  showError(messageText: string, requiredFormatMessage?: boolean): void;
  showSuccess(messageText: string): void;
  showInfo(messageText: string): void;
  showWarning(messageText: string): void;
  showInfoNotificationBox(message: string, description: string): void;
}

const DURATION_MESSAGE = 4;
const DURATION_NOTIFICATION_BOX = 8;

const NotificationService = (): INotificationService => {
  const formatMessageText = (messageText: string) => {
    const splitMessage = messageText.split("-");
    if (splitMessage.length === 2) {
      return splitMessage[1];
    } else return messageText;
  };

  const showMessage = (
    messageText: string,
    type: "success" | "info" | "warning" | "error",
    requiredFormatMessage?: boolean
  ) => {
    message.open({
      content: AlertMessage({
        message: requiredFormatMessage
          ? formatMessageText(messageText)
          : messageText,
        type
      }),
      duration: DURATION_MESSAGE,
      type
    });
  };

  const isRequiredFormatMessage = (value?: boolean) => {
    return typeof value === "undefined" ? true : value;
  };

  return {
    showError(messageText: string, requiredFormatMessage?: boolean) {
      showMessage(
        messageText,
        "error",
        isRequiredFormatMessage(requiredFormatMessage)
      );
    },

    showSuccess(messageText: string) {
      showMessage(messageText, "success");
    },

    showInfo(messageText: string) {
      showMessage(messageText, "info");
    },

    showWarning(messageText: string) {
      showMessage(messageText, "warning");
    },

    showInfoNotificationBox(message: string, description: string) {
      notification.info({
        message,
        description,
        duration: DURATION_NOTIFICATION_BOX
      });
    }
  };
};

export default NotificationService;
